import React from 'react'

import { P } from '@mxenabled/mxui'

import Box from '@mui/material/Box'
import TextareaAutosize from '@mui/material/TextareaAutosize'
import { styled } from '@mui/system'

export interface FeedbackTextProps {
  error?: boolean
  feedbackAriaLabel: string
  feedbackCharacterLimitText?: string
  feedbackDescriptionPlaceHolder?: string
  feedbackLabel: string
  feedbackMessage?: string
  sendAnalytics: () => void
  setFeedbackMessage: (
    event?: React.MouseEvent<HTMLButtonElement, MouseEvent> | string | undefined,
  ) => void
  validateForm: (
    event?: React.MouseEvent<HTMLButtonElement, MouseEvent> | string | undefined,
  ) => void
}

const StyledTextareaAutosize = styled(TextareaAutosize)({
  height: 93,
  resize: 'none',
})

export const BeatFeedbackText: React.FC<FeedbackTextProps> = ({
  error,
  feedbackAriaLabel,
  feedbackCharacterLimitText,
  feedbackDescriptionPlaceHolder,
  feedbackLabel,
  feedbackMessage,
  sendAnalytics,
  setFeedbackMessage,
  validateForm,
}) => {
  return (
    <Box
      aria-label={feedbackLabel}
      sx={{
        marginTop: 24,
        px: 24,
      }}
    >
      <StyledTextareaAutosize
        aria-label={feedbackAriaLabel}
        data-ui-test="feedback-textarea"
        maxRows={4}
        minRows={4}
        name="Feedback"
        onChange={(e: { target: { value: any } }) => {
          setFeedbackMessage(e.target.value)
          validateForm(e.target.value)
        }}
        onClick={() => sendAnalytics()}
        placeholder={feedbackDescriptionPlaceHolder}
        sx={{
          p: 12,
          width: '100%',
        }}
        value={feedbackMessage}
      />
      {feedbackCharacterLimitText && (
        <P
          sx={{
            color: error ? 'error.darker' : null,
            fontSize: 12,
            p: '0px !important',
          }}
        >
          {feedbackCharacterLimitText}
        </P>
      )}
    </Box>
  )
}
